import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "form-business-term mb-2" },
    [
      _c(
        VForm,
        {
          ref: "form",
          staticClass: "form",
          attrs: { readonly: _vm.view },
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return _vm.onSubmit($event)
            },
          },
        },
        [
          _c(
            VTabs,
            {
              model: {
                value: _vm.e1,
                callback: function ($$v) {
                  _vm.e1 = $$v
                },
                expression: "e1",
              },
            },
            [
              _c(
                VTab,
                {
                  attrs: {
                    disabled:
                      (_vm.tplToWork.type || "").toUpperCase() !== "VIEW",
                  },
                },
                [_vm._v("Datos Generales")]
              ),
              _c(
                VTab,
                {
                  attrs: {
                    disabled:
                      (_vm.tplToWork.type || "").toUpperCase() !== "VIEW",
                  },
                },
                [_vm._v("Definición")]
              ),
              _c(
                VTab,
                {
                  attrs: {
                    disabled:
                      (_vm.tplToWork.type || "").toUpperCase() !== "VIEW",
                  },
                },
                [_vm._v("Relaciones")]
              ),
            ],
            1
          ),
          _c(
            VTabsItems,
            {
              model: {
                value: _vm.e1,
                callback: function ($$v) {
                  _vm.e1 = $$v
                },
                expression: "e1",
              },
            },
            [
              _c(
                VTabItem,
                [
                  _c(VRow, [
                    _c(
                      "div",
                      { staticClass: "col-md-2" },
                      [
                        _c(VSubheader, { staticClass: "font-weight-bold" }, [
                          _vm._v(_vm._s(_vm.texts.type)),
                        ]),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-md-4" },
                      [
                        _c(VTextField, {
                          attrs: {
                            disabled: true,
                            small: "",
                            filled: "",
                            dense: "",
                          },
                          model: {
                            value: _vm.type,
                            callback: function ($$v) {
                              _vm.type = $$v
                            },
                            expression: "type",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-md-2" },
                      [
                        _c(VSubheader, { staticClass: "font-weight-bold" }, [
                          _vm._v(_vm._s(_vm.texts.bterm)),
                        ]),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-md-4" },
                      [
                        _c(VTextField, {
                          attrs: {
                            disabled: false,
                            small: "",
                            dense: "",
                            outlined: "",
                            rules: [_vm.rules.required],
                          },
                          model: {
                            value: _vm.business_term,
                            callback: function ($$v) {
                              _vm.business_term = $$v
                            },
                            expression: "business_term",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-md-2" },
                      [
                        _c(VSubheader, { staticClass: "font-weight-bold" }, [
                          _vm._v(_vm._s(_vm.texts.domain)),
                        ]),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-md-4" },
                      [
                        _c(VSelect, {
                          attrs: {
                            variant: _vm.DomainVariant,
                            items: _vm.selectDomain,
                            small: "",
                            dense: "",
                            outlined: "",
                            rules: [_vm.rules.required],
                          },
                          model: {
                            value: _vm.kdomain,
                            callback: function ($$v) {
                              _vm.kdomain = $$v
                            },
                            expression: "kdomain",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-md-2" },
                      [
                        _c(VSubheader, { staticClass: "font-weight-bold" }, [
                          _vm._v(_vm._s(_vm.texts.subdomain)),
                        ]),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-md-4" },
                      [
                        _c(VSelect, {
                          attrs: {
                            variant: _vm.SubdomainVariant,
                            items: _vm.filterSubdomain,
                            small: "",
                            dense: "",
                            outlined: "",
                            "menu-props": {
                              bottom: true,
                              offsetY: true,
                              maxHeight: 200,
                            },
                            attach: _vm.body,
                            rules: [_vm.rules.required],
                          },
                          model: {
                            value: _vm.ksubdomain,
                            callback: function ($$v) {
                              _vm.ksubdomain = $$v
                            },
                            expression: "ksubdomain",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
              _c(
                VTabItem,
                [
                  _c(VRow, [
                    _c(
                      "div",
                      { staticClass: "col-md-2" },
                      [
                        _c(VSubheader, { staticClass: "font-weight-bold" }, [
                          _vm._v(_vm._s(_vm.texts.definition)),
                        ]),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-md-10" },
                      [
                        _c(VTextarea, {
                          attrs: {
                            placeholder: "definition",
                            outlined: "",
                            dense: "",
                            rows: "2",
                            rules: [_vm.rules.required],
                          },
                          model: {
                            value: _vm.definition,
                            callback: function ($$v) {
                              _vm.definition = $$v
                            },
                            expression: "definition",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                  _c(VRow, [
                    _c(
                      "div",
                      { staticClass: "col-md-2" },
                      [
                        _c(VSubheader, { staticClass: "font-weight-bold" }, [
                          _vm._v(_vm._s(_vm.texts.values)),
                        ]),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-md-4" },
                      [
                        _c(VCombobox, {
                          attrs: {
                            items: [],
                            "hide-selected": "",
                            multiple: "",
                            "small-chips": "",
                            outlined: "",
                            dense: "",
                            placeholder: "Add values",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "selection",
                              fn: function (data) {
                                return [
                                  _c(
                                    VChip,
                                    _vm._b(
                                      {
                                        key: JSON.stringify(data.item),
                                        attrs: {
                                          "input-value": data.selected,
                                          disabled: data.disabled,
                                        },
                                        on: {
                                          "click:close": function ($event) {
                                            return data.parent.selectItem(
                                              data.item
                                            )
                                          },
                                        },
                                      },
                                      "v-chip",
                                      data.attrs,
                                      false
                                    ),
                                    [
                                      _c(VAvatar, {
                                        staticClass: "primary white--text",
                                        attrs: { left: "" },
                                        domProps: {
                                          textContent: _vm._s(
                                            data.item.slice(0, 1).toUpperCase()
                                          ),
                                        },
                                      }),
                                      _vm._v(_vm._s(data.item)),
                                      _c(
                                        VIcon,
                                        {
                                          attrs: { small: "" },
                                          on: {
                                            click: function ($event) {
                                              return data.parent.selectItem(
                                                data.item
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v("icon-decline")]
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ]),
                          model: {
                            value: _vm.values,
                            callback: function ($$v) {
                              _vm.values = $$v
                            },
                            expression: "values",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-md-2" },
                      [
                        _c(VSubheader, { staticClass: "font-weight-bold" }, [
                          _vm._v(_vm._s(_vm.texts.class)),
                        ]),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-md-4" },
                      [
                        _c(VCombobox, {
                          attrs: {
                            items: [],
                            "hide-selected": "",
                            multiple: "",
                            "small-chips": "",
                            outlined: "",
                            dense: "",
                            placeholder: "Add values",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "selection",
                              fn: function (data) {
                                return [
                                  _c(
                                    VChip,
                                    _vm._b(
                                      {
                                        key: JSON.stringify(data.item),
                                        attrs: {
                                          "input-value": data.selected,
                                          disabled: data.disabled,
                                        },
                                        on: {
                                          "click:close": function ($event) {
                                            return data.parent.selectItem(
                                              data.item
                                            )
                                          },
                                        },
                                      },
                                      "v-chip",
                                      data.attrs,
                                      false
                                    ),
                                    [
                                      _c(VAvatar, {
                                        staticClass: "primary white--text",
                                        attrs: { left: "" },
                                        domProps: {
                                          textContent: _vm._s(
                                            data.item.slice(0, 1).toUpperCase()
                                          ),
                                        },
                                      }),
                                      _vm._v(_vm._s(data.item)),
                                      _c(
                                        VIcon,
                                        {
                                          attrs: { small: "" },
                                          on: {
                                            click: function ($event) {
                                              return data.parent.selectItem(
                                                data.item
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v("icon-decline")]
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ]),
                          model: {
                            value: _vm.classification,
                            callback: function ($$v) {
                              _vm.classification = $$v
                            },
                            expression: "classification",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                  _c(VRow, [
                    _c(
                      "div",
                      { staticClass: "col-md-2" },
                      [
                        _c(VSubheader, { staticClass: "font-weight-bold" }, [
                          _vm._v(_vm._s(_vm.texts.aka)),
                        ]),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-md-4" },
                      [
                        _c(VTextField, {
                          attrs: { disabled: false, outlined: "", dense: "" },
                          model: {
                            value: _vm.also_known_as,
                            callback: function ($$v) {
                              _vm.also_known_as = $$v
                            },
                            expression: "also_known_as",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-md-2" },
                      [
                        _c(VSubheader, { staticClass: "font-weight-bold" }, [
                          _vm._v(_vm._s(_vm.texts.accountable)),
                        ]),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-md-4" },
                      [
                        _c(VTextField, {
                          attrs: {
                            disabled: false,
                            dense: "",
                            outlined: "",
                            type: "email",
                            rules: [_vm.rules.email, _vm.rules.required],
                          },
                          model: {
                            value: _vm.accountable,
                            callback: function ($$v) {
                              _vm.accountable = $$v
                            },
                            expression: "accountable",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                  _c(VRow, [
                    _c(
                      "div",
                      { staticClass: "col-md-2" },
                      [
                        _c(VSubheader, { staticClass: "font-weight-bold" }, [
                          _vm._v(_vm._s(_vm.$t("frases.is_critical"))),
                        ]),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-md-4" },
                      [
                        _c(VCheckbox, {
                          attrs: {
                            name: "check-button",
                            dense: "",
                            small: "",
                            color: "primary",
                          },
                          model: {
                            value: _vm.critical,
                            callback: function ($$v) {
                              _vm.critical = $$v
                            },
                            expression: "critical",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-md-2" },
                      [
                        _c(VSubheader, { staticClass: "font-weight-bold" }, [
                          _vm._v(_vm._s(_vm.$t("frases.active"))),
                        ]),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-md-4" },
                      [
                        _c(VCheckbox, {
                          attrs: {
                            name: "check-button",
                            dense: "",
                            small: "",
                            color: "primary",
                          },
                          model: {
                            value: _vm.status,
                            callback: function ($$v) {
                              _vm.status = $$v
                            },
                            expression: "status",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm.isDomainItc
                      ? _c(
                          "div",
                          { staticClass: "col-md-2" },
                          [
                            _c(
                              VSubheader,
                              { staticClass: "font-weight-bold" },
                              [_vm._v(_vm._s(_vm.$t("frases.shared")))]
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.isDomainItc
                      ? _c(
                          "div",
                          { staticClass: "col-md-4" },
                          [
                            _c(VCheckbox, {
                              attrs: {
                                name: "check-button",
                                small: "",
                                dense: "",
                                color: "primary",
                              },
                              model: {
                                value: _vm.shared,
                                callback: function ($$v) {
                                  _vm.shared = $$v
                                },
                                expression: "shared",
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]),
                ],
                1
              ),
              _c(
                VTabItem,
                [
                  _c("b-row", [
                    _c(
                      "div",
                      { staticClass: "col-md-2" },
                      [
                        _c(VSubheader, { staticClass: "font-weight-bold" }, [
                          _vm._v(_vm._s(_vm.texts.is_contained)),
                        ]),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-md-4" },
                      [
                        _c(VCombobox, {
                          attrs: {
                            items: _vm.availableOptions(_vm.is_contained_in),
                            "hide-selected": "",
                            multiple: "",
                            "small-chips": "",
                            outlined: "",
                            dense: "",
                            "small-chips": true,
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "selection",
                              fn: function (data) {
                                return [
                                  _c(
                                    VChip,
                                    _vm._b(
                                      {
                                        key: JSON.stringify(data.item),
                                        attrs: {
                                          "input-value": data.selected,
                                          disabled: data.disabled,
                                        },
                                        on: {
                                          "click:close": function ($event) {
                                            return data.parent.selectItem(
                                              data.item
                                            )
                                          },
                                        },
                                      },
                                      "v-chip",
                                      data.attrs,
                                      false
                                    ),
                                    [
                                      _c(VAvatar, {
                                        staticClass: "primary white--text",
                                        attrs: { left: "" },
                                        domProps: {
                                          textContent: _vm._s(
                                            data.item.slice(0, 1).toUpperCase()
                                          ),
                                        },
                                      }),
                                      _vm._v(_vm._s(data.item)),
                                      _c(
                                        VIcon,
                                        {
                                          attrs: { small: "" },
                                          on: {
                                            click: function ($event) {
                                              return data.parent.selectItem(
                                                data.item
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v("icon-decline")]
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ]),
                          model: {
                            value: _vm.is_contained_in,
                            callback: function ($$v) {
                              _vm.is_contained_in = $$v
                            },
                            expression: "is_contained_in",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-md-2" },
                      [
                        _c(VSubheader, { staticClass: "font-weight-bold" }, [
                          _vm._v(_vm._s(_vm.texts.is_related)),
                        ]),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-md-4" },
                      [
                        _c(VCombobox, {
                          attrs: {
                            items: _vm.availableOptions(
                              _vm.is_a_related_term_from
                            ),
                            "hide-selected": "",
                            multiple: "",
                            "small-chips": "",
                            outlined: "",
                            dense: "",
                            "small-chips": true,
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "selection",
                              fn: function (data) {
                                return [
                                  _c(
                                    VChip,
                                    _vm._b(
                                      {
                                        key: JSON.stringify(data.item),
                                        attrs: {
                                          "input-value": data.selected,
                                          disabled: data.disabled,
                                        },
                                        on: {
                                          "click:close": function ($event) {
                                            return data.parent.selectItem(
                                              data.item
                                            )
                                          },
                                        },
                                      },
                                      "v-chip",
                                      data.attrs,
                                      false
                                    ),
                                    [
                                      _c(VAvatar, {
                                        staticClass: "primary white--text",
                                        attrs: { left: "" },
                                        domProps: {
                                          textContent: _vm._s(
                                            data.item.slice(0, 1).toUpperCase()
                                          ),
                                        },
                                      }),
                                      _vm._v(_vm._s(data.item)),
                                      _c(
                                        VIcon,
                                        {
                                          attrs: { small: "" },
                                          on: {
                                            click: function ($event) {
                                              return data.parent.selectItem(
                                                data.item
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v("icon-decline")]
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ]),
                          model: {
                            value: _vm.is_a_related_term_from,
                            callback: function ($$v) {
                              _vm.is_a_related_term_from = $$v
                            },
                            expression: "is_a_related_term_from",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                  _c(VRow, [
                    _c(
                      "div",
                      { staticClass: "col-md-2" },
                      [
                        _c(VSubheader, { staticClass: "font-weight-bold" }, [
                          _vm._v(_vm._s(_vm.texts.is_type)),
                        ]),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-md-4" },
                      [
                        _c(VCombobox, {
                          attrs: {
                            items: _vm.availableOptions(_vm.is_a_type_of),
                            "hide-selected": "",
                            multiple: "",
                            "small-chips": "",
                            outlined: "",
                            dense: "",
                            "small-chips": true,
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "selection",
                              fn: function (data) {
                                return [
                                  _c(
                                    VChip,
                                    _vm._b(
                                      {
                                        key: JSON.stringify(data.item),
                                        attrs: {
                                          "input-value": data.selected,
                                          disabled: data.disabled,
                                        },
                                        on: {
                                          "click:close": function ($event) {
                                            return data.parent.selectItem(
                                              data.item
                                            )
                                          },
                                        },
                                      },
                                      "v-chip",
                                      data.attrs,
                                      false
                                    ),
                                    [
                                      _c(VAvatar, {
                                        staticClass: "primary white--text",
                                        attrs: { left: "" },
                                        domProps: {
                                          textContent: _vm._s(
                                            data.item.slice(0, 1).toUpperCase()
                                          ),
                                        },
                                      }),
                                      _vm._v(_vm._s(data.item)),
                                      _c(
                                        VIcon,
                                        {
                                          attrs: { small: "" },
                                          on: {
                                            click: function ($event) {
                                              return data.parent.selectItem(
                                                data.item
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v("icon-decline")]
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ]),
                          model: {
                            value: _vm.is_a_type_of,
                            callback: function ($$v) {
                              _vm.is_a_type_of = $$v
                            },
                            expression: "is_a_type_of",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-md-2" },
                      [
                        _c(VSubheader, { staticClass: "font-weight-bold" }, [
                          _vm._v(_vm._s(_vm.texts.is_used)),
                        ]),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-md-4" },
                      [
                        _c(VCombobox, {
                          attrs: {
                            items: _vm.availableOptions(_vm.is_calculated_from),
                            "hide-selected": "",
                            multiple: "",
                            "small-chips": "",
                            outlined: "",
                            dense: "",
                            "small-chips": true,
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "selection",
                              fn: function (data) {
                                return [
                                  _c(
                                    VChip,
                                    _vm._b(
                                      {
                                        key: JSON.stringify(data.item),
                                        attrs: {
                                          "input-value": data.selected,
                                          disabled: data.disabled,
                                        },
                                        on: {
                                          "click:close": function ($event) {
                                            return data.parent.selectItem(
                                              data.item
                                            )
                                          },
                                        },
                                      },
                                      "v-chip",
                                      data.attrs,
                                      false
                                    ),
                                    [
                                      _c(VAvatar, {
                                        staticClass: "primary white--text",
                                        attrs: { left: "" },
                                        domProps: {
                                          textContent: _vm._s(
                                            data.item.slice(0, 1).toUpperCase()
                                          ),
                                        },
                                      }),
                                      _vm._v(_vm._s(data.item)),
                                      _c(
                                        VIcon,
                                        {
                                          attrs: { small: "" },
                                          on: {
                                            click: function ($event) {
                                              return data.parent.selectItem(
                                                data.item
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v("icon-decline")]
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ]),
                          model: {
                            value: _vm.is_calculated_from,
                            callback: function ($$v) {
                              _vm.is_calculated_from = $$v
                            },
                            expression: "is_calculated_from",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            VRow,
            { attrs: { justify: "center" } },
            [
              (_vm.tplToWork.type || "").toUpperCase() !== "VIEW" && _vm.e1 > 0
                ? _c(
                    VBtn,
                    {
                      staticClass: "mt-4 mr-2",
                      attrs: { text: "", outlined: "" },
                      on: {
                        click: function ($event) {
                          _vm.e1 > 0 && _vm.e1--
                        },
                      },
                    },
                    [_vm._v("Atrás")]
                  )
                : _vm._e(),
              (_vm.tplToWork.type || "").toUpperCase() !== "VIEW" && _vm.e1 < 2
                ? _c(
                    VBtn,
                    {
                      staticClass: "mt-4",
                      attrs: { color: "primary" },
                      on: { click: _vm.nextStep },
                    },
                    [_vm._v("Siguiente")]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }